import React from 'react';
import Navbar from '@/pages/Navbar/Navbar';
import Rodape from '@/pages/Rodape/Rodape';
import limpezaImage from '@/assets/sobre.png'; // ajuste o caminho se necessário
import ImagemFlutuante from '@/components/ImagemFlutuante';

export default function Sobre() {
  return (
    <>
      <Navbar />
      <ImagemFlutuante />

      <main className="bg-white text-gray-800 font-sans pt-12 pb-20">
        <section className="max-w-7xl mx-auto px-4 py-12 flex flex-col md:flex-row items-center gap-12">
          {/* Imagem */}
<div className="relative md:w-1/2 w-full max-w-2xl mx-auto">
  <img
    src={limpezaImage}
    alt="Limpeza Master Clean"
    className="rounded-xl shadow-2xl w-full h-[400px] object-cover transform transition-transform duration-300 hover:scale-105"
  />

  {/* Gradiente escuro por cima */}
  <div className="absolute inset-0 rounded-xl bg-gradient-to-t from-black/60 via-black/20 to-transparent" />

  {/* Faixa dourada personalizada */}
  <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-r from-[#c9aa7b] via-[#b8936a] to-[#a48159] rounded-b-xl shadow-lg" />

  {/* Brilho sutil ao passar o mouse */}
  <div className="absolute inset-0 rounded-xl shadow-[0_0_25px_rgba(201,170,123,0.4)] opacity-0 hover:opacity-100 transition-opacity duration-300" />
</div>


         <div className="md:w-1/2 space-y-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
  <h1 className="text-2xl md:text-3xl font-bold text-[#3b2e2e] leading-snug">
    Viva a experiência Prime Higienizações
  </h1>

  <h2 className="text-base font-medium text-[#3b2e2e] leading-relaxed">
    Transformamos o cuidado com seu lar em um verdadeiro compromisso com a saúde, o bem-estar e a excelência.
  </h2>

  <p className="text-justify leading-[1.8] text-[#444]">
    Atuando com seriedade e excelência, a <strong className="text-[#3b2e2e] font-semibold">Prime Higienizações</strong> é referência em serviços especializados de limpeza
    ecológica. Utilizamos <span className="italic">produtos biodegradáveis</span> e equipamentos de última geração, garantindo ambientes mais seguros e confortáveis
    para você e sua família — sempre com respeito ao meio ambiente.
  </p>

  <p className="text-justify leading-[1.8] text-[#444]">
    Nossa reputação foi construída com base na <span className="font-medium text-[#3b2e2e]">confiança</span>, <span className="font-medium text-[#3b2e2e]">eficiência</span> e em um atendimento personalizado.
    A Prime Higienizações tem orgulho de oferecer um dos melhores <strong className="text-[#3b2e2e] font-semibold">custos-benefícios</strong> do mercado, aliando tecnologia,
    responsabilidade e cuidado em cada detalhe.
  </p>
</div>


        </section>
      </main>

      <Rodape />
    </>
  );
}
